import type { BootstrapOptions } from 'mini-bootstrap';
import type { Module } from 'mini-common-schema';

const moduleToMainComponentMap: {
    [P in Module]?: BootstrapOptions;
} = {};

export function registerBootstrapOptions(options: BootstrapOptions) {
    const module = options.appModuleProps.module;
    moduleToMainComponentMap[module] = options;
}

export function getBootstrapOptions(module: Module): BootstrapOptions | undefined {
    return moduleToMainComponentMap[module];
}
